const legacy = "legacy";
import "core-js/stable";
import "regenerator-runtime/runtime";
console.log(legacy);
